import React from 'react';
import { Box, Typography, Card, CardContent, Avatar, Rating } from '@mui/material';
import { motion } from 'framer-motion';
import testimonials1 from '../assets/testimonial-min.png';
import testimonials2 from '../assets/testimonial2-min.png';
import testimonials3 from '../assets/testimonial3-min.png';

const testimonials = [
  {
    name: 'Maaya',
    role: 'Wellness Coach & Yoga Enthusiast',
    photo: testimonials1,
    rating: 5,
    quote: 'Mindmapper AI has completely changed how I understand my dreams. It’s like having a gentle guide helping me reflect, heal, and grow every morning. The personalized meditations are my favorite part—they feel like they were made just for me.',
  },
  {
    name: 'Jason Lee',
    role: 'Creative Director & Dream Journaler',
    photo: testimonials2,
    rating: 5,
    quote: 'I started using Mindmapper AI out of curiosity, but now it’s part of my nightly routine. It doesn’t just interpret dreams—it helps me make sense of what’s going on in my head. The dream cloud feature? Game changer.',
  },

  {
    name: 'Sophia Reynolds',
    role: 'Mindfulness Blogger & Psychology Grad',
    photo: testimonials3,
    rating: 4.5 ,
    quote: 'Mindmapper AI bridges science and intuition in a way I haven’t seen before. The dream interpretations are not only insightful but grounded, and I love how the app grows with my journey. It’s like journaling—but smarter.',
  },
  // ... more
];

const TestimonialsSection = () => {
  return (
    <Box sx={{ py: 10, backgroundColor: '#fafafa',width: '100%' }}>
      <Typography variant="h3" align="center" sx={{ mb: 6 }}>
        What Our Users Say
      </Typography>
      <Box
        sx={{
          display: 'flex',
          overflowX: 'auto',
          alignContent: 'center',
          justifyContent: 'center',
          padding: 2,
          px: 2,
          gap: 4,
          scrollBehavior: 'smooth',
          '&::-webkit-scrollbar': { display: 'none' },
        }}
      >
        {testimonials.map((t, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, scale: 0.85 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <Card sx={{ minWidth: 300, maxWidth: 320, mx: 'auto',height:450 }} elevation={3}>
              <CardContent sx={{ textAlign: 'center', p: 3 }}>
                <Avatar
                  src={t.photo}
                  alt={t.name}
                  sx={{ width: 64, height: 64, mx: 'auto', mb: 2 }}
                />
                <Rating value={t.rating} readOnly sx={{ mb: 1 }} />
                <Typography variant="subtitle1" fontWeight={600}>
                  {t.name}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {t.role}
                </Typography>
                <Typography variant="body1" sx={{ fontStyle: 'italic', mb: 2,mt:2 }}>
                  "{t.quote}"
                </Typography>
              
              </CardContent>
            </Card>
          </motion.div>
        ))}
      </Box>
    </Box>
  );
};

export default TestimonialsSection;
